import { withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import {
	WixCustomElementComponentEditorAPISymbol,
	WixCustomElementComponentEditorFeatureAPI,
} from 'feature-wix-custom-element-component'
import _ from 'lodash'

const viewerManagerCustomElementsApiFactory = (
	wixCustomElementComponentEditorFeatureAPI: WixCustomElementComponentEditorFeatureAPI
): IViewerManagerImplementor<'customElements'> => {
	const fileCacheCounter: Record<string, number> = {}
	return {
		customElements: {
			getCacheKillerCounter(fileId: string) {
				return fileCacheCounter[fileId] || 0
			},
			// TODO: when finish implementing ds-custom-elements, remove comment
			setCacheKillerCounter(fileId: string, cacheKillerCounter: number) {
				fileCacheCounter[fileId] = cacheKillerCounter
				wixCustomElementComponentEditorFeatureAPI.onCorvidContentUpdate(fileId, cacheKillerCounter)
			},
			getCacheKillerMap() {
				return fileCacheCounter
			},
			setCacheKillerMap(value) {
				// TODO: Refactor so that we only receive the changed file and not the whole map.. @talm
				const changedFileIdObj = _.omitBy(value, (__, fileId) => fileCacheCounter[fileId] === value[fileId])
				const fileId = Object.keys(changedFileIdObj)[0]

				this.setCacheKillerCounter(fileId, changedFileIdObj[fileId])
			},
		},
	}
}
export const ViewerManagerCustomElementsApi = withDependencies(
	[WixCustomElementComponentEditorAPISymbol],
	viewerManagerCustomElementsApiFactory
)
